import React from 'react';
import { PropTypes } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  yes: { id: 'desc.yes', defaultMessage: 'YES' },
  no: { id: 'desc.no', defaultMessage: 'NO' },
});

const SelectedAccountLineInfo = ({ description, value, intl: { formatMessage } }) => {
  let valueColor;
  switch (value) {
    case 'YES':
      valueColor = 'green';
      break;
    case 'NO':
      valueColor = 'red';
      break;
    default:
      valueColor = '';
      break;
  }
  return (
    <div className="p-grid" style={{ borderBottom: '1px dashed black' }}>
      <strong className="p-col-5">
        {description === 'YES' && formatMessage(messages.yes)}
        {description === 'NO' && formatMessage(messages.no)}
        {(description !== 'YES' && description !== 'NO') && description}
        {' '}
      </strong>
      <div className="p-col-2">
        |
      </div>
      <div className="p-col-5" style={{ color: valueColor }}>
        {' '}
        {value}
      </div>
    </div>
  );
};

SelectedAccountLineInfo.propTypes = {
  description: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};


export default injectIntl(SelectedAccountLineInfo);
